export default "__VITE_ASSET__CqZzz$bn__"